[
  {
    "code": "folder.view",
    "domain": "目录",
    "description": "内容库目录治理（删除仅限空目录）",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "folder.create",
    "domain": "目录",
    "description": "内容库目录治理（删除仅限空目录）",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "folder.update",
    "domain": "目录",
    "description": "内容库目录治理（删除仅限空目录）",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "folder.move",
    "domain": "目录",
    "description": "内容库目录治理（删除仅限空目录）",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "folder.delete",
    "domain": "目录",
    "description": "内容库目录治理（删除仅限空目录）",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "asset.view",
    "domain": "资产",
    "description": "浏览与预览",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "asset.download",
    "domain": "资产",
    "description": "下载已批准文件",
    "default_roles": [
      "bd",
      "content_owner",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "asset.create",
    "domain": "资产",
    "description": "新建 Asset",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "asset.update_metadata",
    "domain": "资产",
    "description": "编辑元数据",
    "default_roles": [
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "asset.move",
    "domain": "资产",
    "description": "移动目录",
    "default_roles": [
      "content_owner",
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "asset.archive",
    "domain": "资产",
    "description": "归档删除（软）",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "asset.manage",
    "domain": "资产",
    "description": "资产级综合管理",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "asset.upload_revision",
    "domain": "资产",
    "description": "上传新修订",
    "default_roles": [
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "content.description.update",
    "domain": "说明",
    "description": "文档说明维护",
    "default_roles": [
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "content.page_description.update",
    "domain": "说明",
    "description": "单页说明维护",
    "default_roles": [
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "content.note.read",
    "domain": "备注",
    "description": "多人备注",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "content.note.create",
    "domain": "备注",
    "description": "多人备注",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "content.note.update",
    "domain": "备注",
    "description": "多人备注",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "content.note.resolve",
    "domain": "备注",
    "description": "多人备注",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "favorite.view",
    "domain": "收藏",
    "description": "个人收藏与收藏夹",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": false
  },
  {
    "code": "favorite.create",
    "domain": "收藏",
    "description": "个人收藏与收藏夹",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": false
  },
  {
    "code": "favorite.delete",
    "domain": "收藏",
    "description": "个人收藏与收藏夹",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": false
  },
  {
    "code": "favorite.folder.manage",
    "domain": "收藏",
    "description": "个人收藏与收藏夹",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": false
  },
  {
    "code": "revision.preview_original",
    "domain": "修订",
    "description": "原始 PPT 只读预览（不含下载权）",
    "default_roles": [
      "content_owner",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.diff_process",
    "domain": "修订",
    "description": "差异处理工作台动作与清单生成",
    "default_roles": [
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "revision.review",
    "domain": "修订",
    "description": "查看审核任务与填写意见",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.approve",
    "domain": "修订",
    "description": "逐项纳入/不生效决策",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.publish",
    "domain": "修订",
    "description": "发布基线切换",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.rollback",
    "domain": "修订",
    "description": "生命周期动作",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.withdraw",
    "domain": "修订",
    "description": "生命周期动作",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.quarantine",
    "domain": "修订",
    "description": "生命周期动作",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.restore",
    "domain": "修订",
    "description": "生命周期动作",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.renew",
    "domain": "修订",
    "description": "生命周期动作",
    "default_roles": [
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "revision.expire_scan",
    "domain": "修订",
    "description": "触发到期扫描",
    "default_roles": [
      "system_admin"
    ],
    "abac": false
  },
  {
    "code": "knowledge.baseline.publish",
    "domain": "复用",
    "description": "发布知识库基线/模块；Module 提炼与编辑",
    "default_roles": [
      "librarian",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "knowledge.module.publish",
    "domain": "复用",
    "description": "发布知识库基线/模块；Module 提炼与编辑",
    "default_roles": [
      "librarian",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "module.manage",
    "domain": "复用",
    "description": "发布知识库基线/模块；Module 提炼与编辑",
    "default_roles": [
      "librarian",
      "content_owner"
    ],
    "abac": true
  },
  {
    "code": "crosslang.pair.manage",
    "domain": "跨语言",
    "description": "维护 AssetGroup 与跨语言对照",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "redaction.derivative.create",
    "domain": "脱敏",
    "description": "脱敏派生创建/审批",
    "default_roles": [
      "content_owner",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "redaction.derivative.approve",
    "domain": "脱敏",
    "description": "脱敏派生创建/审批",
    "default_roles": [
      "content_owner",
      "reviewer"
    ],
    "abac": true
  },
  {
    "code": "page.search",
    "domain": "检索",
    "description": "页面检索、引用、导出",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "page.quote",
    "domain": "检索",
    "description": "页面检索、引用、导出",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "page.export",
    "domain": "检索",
    "description": "页面检索、引用、导出",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "kb.ask",
    "domain": "问答",
    "description": "问答、反馈、查看调用追踪",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "kb.feedback",
    "domain": "问答",
    "description": "问答、反馈、查看调用追踪",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "kb.trace.view",
    "domain": "问答",
    "description": "问答、反馈、查看调用追踪",
    "default_roles": [
      "auditor",
      "bd",
      "content_owner",
      "delivery_reviewer",
      "iam_admin",
      "librarian",
      "project_owner",
      "reviewer",
      "system_admin",
      "viewer"
    ],
    "abac": true
  },
  {
    "code": "kb.answer.add_to_project",
    "domain": "问答",
    "description": "把回答引用页加入项目页面计划草稿",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "rfp.upload",
    "domain": "RFP",
    "description": "RFP 解析与需求确认",
    "default_roles": [
      "bd",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "rfp.analyze",
    "domain": "RFP",
    "description": "RFP 解析与需求确认",
    "default_roles": [
      "bd",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "requirement.confirm",
    "domain": "RFP",
    "description": "RFP 解析与需求确认",
    "default_roles": [
      "bd",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "recommendation.confirm",
    "domain": "RFP",
    "description": "RFP 解析与需求确认",
    "default_roles": [
      "bd",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.create",
    "domain": "项目",
    "description": "项目创建与维护",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.view",
    "domain": "项目",
    "description": "项目创建与维护",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.edit",
    "domain": "项目",
    "description": "项目创建与维护",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.manage",
    "domain": "项目",
    "description": "项目设置与成员",
    "default_roles": [
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.manage_members",
    "domain": "项目",
    "description": "项目设置与成员",
    "default_roles": [
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.owner_transfer",
    "domain": "项目",
    "description": "负责人转让",
    "default_roles": [
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.folder.manage",
    "domain": "项目",
    "description": "项目目录与资料",
    "default_roles": [
      "project_owner",
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.file.manage",
    "domain": "项目",
    "description": "项目目录与资料",
    "default_roles": [
      "project_owner",
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.ai_analyze",
    "domain": "项目",
    "description": "提交 AI 分析、单页推荐",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.page_plan.edit",
    "domain": "项目",
    "description": "页面计划编辑与保存",
    "default_roles": [
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.page_plan.confirm_expired",
    "domain": "项目",
    "description": "显式确认使用已过期素材",
    "default_roles": [
      "bd",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.baseline.upgrade",
    "domain": "项目",
    "description": "项目基线升级",
    "default_roles": [
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.assemble",
    "domain": "项目",
    "description": "生成 PPT 初稿",
    "default_roles": [
      "project_owner",
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.freeze",
    "domain": "项目",
    "description": "交付冻结",
    "default_roles": [
      "delivery_reviewer",
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.download",
    "domain": "项目",
    "description": "**仅项目资料导出**（不得用于交付物）",
    "default_roles": [
      "project_owner"
    ],
    "abac": true
  },
  {
    "code": "project.deck.cleanup",
    "domain": "项目",
    "description": "清理项目历史 PPT 成品副本",
    "default_roles": [
      "project_owner",
      "bd"
    ],
    "abac": true
  },
  {
    "code": "project.archive",
    "domain": "项目",
    "description": "生命周期",
    "default_roles": [
      "project_owner",
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "project.restore",
    "domain": "项目",
    "description": "生命周期",
    "default_roles": [
      "project_owner",
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "project.delete",
    "domain": "项目",
    "description": "生命周期",
    "default_roles": [
      "project_owner",
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "delivery.view",
    "domain": "交付",
    "description": "交付记录、**交付物（Artifact/Manifest）下载**、第二人审批（下载唯一由 `delivery.download` 管控，见 D-30）",
    "default_roles": [
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "delivery.download",
    "domain": "交付",
    "description": "交付记录、**交付物（Artifact/Manifest）下载**、第二人审批（下载唯一由 `delivery.download` 管控，见 D-30）",
    "default_roles": [
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "delivery.approve",
    "domain": "交付",
    "description": "交付记录、**交付物（Artifact/Manifest）下载**、第二人审批（下载唯一由 `delivery.download` 管控，见 D-30）",
    "default_roles": [
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "ppt.attribute_check.retry",
    "domain": "PPT",
    "description": "属性清理重试（生成统一使用 `project.assemble`；`ppt.generate` 自 v1.8 起为废弃别名，不新增使用）",
    "default_roles": [
      "project_owner",
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "ppt.manual_insert.submit",
    "domain": "PPT",
    "description": "人工插入提交与核验",
    "default_roles": [
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "ppt.manual_insert.verify",
    "domain": "PPT",
    "description": "人工插入提交与核验",
    "default_roles": [
      "delivery_reviewer"
    ],
    "abac": true
  },
  {
    "code": "ops.task.view",
    "domain": "运营",
    "description": "任务中心",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ops.task.retry",
    "domain": "运营",
    "description": "任务中心",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ops.task.cancel",
    "domain": "运营",
    "description": "任务中心",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ops.deadletter.manage",
    "domain": "运营",
    "description": "任务中心",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ops.expiry.manage",
    "domain": "运营",
    "description": "失效提醒、评测、成本",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "ops.eval.manage",
    "domain": "运营",
    "description": "失效提醒、评测、成本",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "ops.cost.view",
    "domain": "运营",
    "description": "失效提醒、评测、成本",
    "default_roles": [
      "librarian"
    ],
    "abac": true
  },
  {
    "code": "ops.compliance_delete.request",
    "domain": "运营",
    "description": "合规删除、法律保全、留存策略",
    "default_roles": [],
    "abac": true
  },
  {
    "code": "ops.compliance_delete.approve",
    "domain": "运营",
    "description": "合规删除、法律保全、留存策略",
    "default_roles": [],
    "abac": true
  },
  {
    "code": "ops.legal_hold.manage",
    "domain": "运营",
    "description": "合规删除、法律保全、留存策略",
    "default_roles": [],
    "abac": true
  },
  {
    "code": "ops.retention.manage",
    "domain": "运营",
    "description": "合规删除、法律保全、留存策略",
    "default_roles": [],
    "abac": true
  },
  {
    "code": "audit.view",
    "domain": "审计",
    "description": "审计查询与脱敏导出",
    "default_roles": [
      "auditor",
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "audit.export",
    "domain": "审计",
    "description": "审计查询与脱敏导出",
    "default_roles": [
      "auditor",
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "identity.user.manage",
    "domain": "身份",
    "description": "账号、组、角色、策略",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "identity.group.manage",
    "domain": "身份",
    "description": "账号、组、角色、策略",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "identity.role.manage",
    "domain": "身份",
    "description": "账号、组、角色、策略",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "identity.policy.manage",
    "domain": "身份",
    "description": "账号、组、角色、策略",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.grant",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.revoke",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.view",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.preview",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.approve_temporary",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "access.break_glass",
    "domain": "访问",
    "description": "授权绑定、撤权、访问解释、策略预演、临时与破窗授权",
    "default_roles": [
      "iam_admin"
    ],
    "abac": true
  },
  {
    "code": "system.manage",
    "domain": "系统",
    "description": "平台配置、服务账号、存储与留存",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "integration.service_account.manage",
    "domain": "系统",
    "description": "平台配置、服务账号、存储与留存",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "storage.manage",
    "domain": "系统",
    "description": "平台配置、服务账号、存储与留存",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.provider.view",
    "domain": "AI 配置",
    "description": "供应商与模型档案",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.provider.manage",
    "domain": "AI 配置",
    "description": "供应商与模型档案",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.model.view",
    "domain": "AI 配置",
    "description": "供应商与模型档案",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.model.manage",
    "domain": "AI 配置",
    "description": "供应商与模型档案",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.secret.view_metadata",
    "domain": "AI 配置",
    "description": "Key 池",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.secret.create",
    "domain": "AI 配置",
    "description": "Key 池",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.secret.rotate",
    "domain": "AI 配置",
    "description": "Key 池",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.secret.disable",
    "domain": "AI 配置",
    "description": "Key 池",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.secret.manual_recover",
    "domain": "AI 配置",
    "description": "Key 池",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.route.view",
    "domain": "AI 配置",
    "description": "路由、健康、成本、审计",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.route.manage",
    "domain": "AI 配置",
    "description": "路由、健康、成本、审计",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.health_check",
    "domain": "AI 配置",
    "description": "路由、健康、成本、审计",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.cost.view",
    "domain": "AI 配置",
    "description": "路由、健康、成本、审计",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "ai.audit.view",
    "domain": "AI 配置",
    "description": "路由、健康、成本、审计",
    "default_roles": [
      "system_admin"
    ],
    "abac": true
  },
  {
    "code": "asset.access.manage",
    "domain": "资产",
    "description": "管理文件与目录访问及搜索权限",
    "default_roles": [
      "iam_admin",
      "system_admin"
    ],
    "abac": true
  }
]
